import * as React from 'react';

// import { formatStores } from '../../../utils/normalizers';
import { ReleaseStore } from '@common/types/release/release-store';
// import { GenericDropdownBuilder } from '../../form/dropdown/index';
import Radio from '@components/form/radio';
import styled from 'styled-components';
import { formatStores } from '@webapp/utils/normalizers';
import { GenericDropdownBuilder } from '@webapp/controllers/form/dropdown';
import { Translate } from 'react-localize-redux';

interface StoreSelectorCtrlProps {
  className?: string;
  stores: ReleaseStore[];
  activeStore: ReleaseStore[];
  setActiveStore: React.Dispatch<React.SetStateAction<ReleaseStore[]>>;
  isDarker?: boolean;
}

const DropdownCtrl = GenericDropdownBuilder<ReleaseStore[]>();

export const StoreSelectorCtrl: React.FC<StoreSelectorCtrlProps> = (props) => {
  const { stores, activeStore, setActiveStore } = props;
  React.useEffect(() => {
    setActiveStore(stores);
  }, [stores, setActiveStore]);
  const getTitle = () => {
    return formatStores(
      activeStore,
      stores.map((s) => s.name)
    );
  };

  const isSelected = (storeId: string) => {
    const allSelected = activeStore?.length === props.stores.length;

    if (storeId === 'all') {
      return allSelected;
    }

    if (activeStore?.find((a) => storeId === a.id)) {
      return true;
    }

    return false;
  };

  const handleSelection = (store?: ReleaseStore) => {
    let newStores: ReleaseStore[] = activeStore || [];

    if (!store) {
      if (isSelected('all')) {
        newStores = [];
        setActiveStore(newStores);
      } else {
        newStores = props.stores;
        setActiveStore(newStores);
      }
    }

    if (store) {
      if (isSelected(store.id)) {
        newStores = newStores.filter((c) => c.id !== store.id);
        setActiveStore(newStores);
      } else {
        newStores = newStores.concat([store]);
        setActiveStore(newStores);
      }
    }
  };

  return (
    <div className={props.className}>
      <DropdownCtrl
        title={<Translate id="RELEASE.DATES_STORES.STORES.LABEL" />}
        value={activeStore}
        valueMapper={() => getTitle()}
        isDark={true}
        isDarker={props.isDarker}
      >
        <div>
          <Radio
            className="radio-store"
            isChecked={isSelected('all')}
            onChange={() => handleSelection()}
            isDark={true}
          >
            <Translate
              id="RELEASE.DATES_STORES.STORES.OPTION.ALL"
              data={{ amount: props.stores.length }}
            />
          </Radio>
          {props.stores.map((store) => (
            <Radio
              isDark={true}
              key={`store-${store.id}`}
              className="radio-store"
              isChecked={isSelected(store.id as string)}
              onChange={() => handleSelection(store as ReleaseStore)}
            >
              {store.name}
            </Radio>
          ))}
        </div>
      </DropdownCtrl>
    </div>
  );
};

export default styled(StoreSelectorCtrl)`
  .radio-store {
    margin-top: 14px;
    background-color: ${({ theme }) => theme.colors.primary};
    &:first-child {
      margin-top: 0;
    }
  }
`;
